import React from 'react';
import { createFeature, useFlow } from '@edreamsodigeo/frontend-core';

import { useLogin } from '~clientState/providers/LoginProvider';
import {
  FLIGHT_SUMMARY_HOTELS_MAP_NON_PRIME,
  FLIGHT_SUMMARY_HOTELS_MAP_PRIME,
} from '~clientState/ab';
import HotelDealsMobileCard from './components/HotelDealsMobileCard/HotelDealsMobileCard';
import FlightSummaryHotelsMap from './components/FlightSummaryHotelsMap/FlightSummaryHotelsMap';
import type { FlightSummaryHotelsMapProps } from './components/FlightSummaryHotelsMap/FlightSummaryHotelsMap';
import type { HotelDealsMobileCardProps } from './components/HotelDealsMobileCard/HotelDealsMobileCard';
import PixelTracking from '~shared/PixelTracking';

export type HotelDealsMobileCardContainerProps = FlightSummaryHotelsMapProps &
  HotelDealsMobileCardProps & {
    isTrain?: boolean;
    isMultiDestination?: boolean;
    isMeta?: boolean;
  };

const FlightSummaryHotelsMapPrime =
  createFeature<HotelDealsMobileCardContainerProps>({
    variations: [HotelDealsMobileCard, FlightSummaryHotelsMap],
    version: 1,
    name: FLIGHT_SUMMARY_HOTELS_MAP_PRIME,
  });

const FlightSummaryHotelsMapNonPrime =
  createFeature<HotelDealsMobileCardContainerProps>({
    variations: [HotelDealsMobileCard, FlightSummaryHotelsMap],
    version: 1,
    name: FLIGHT_SUMMARY_HOTELS_MAP_NON_PRIME,
  });

export default (props: HotelDealsMobileCardContainerProps) => {
  const flow: 'mobile' | 'desktop' = useFlow();
  const { isPrime } = useLogin();

  if (
    props.isMeta ||
    flow === 'desktop' ||
    props.isMultiDestination ||
    props.isTrain
  ) {
    return (
      <PixelTracking
        datameshId="hotels-in-flights_not-displayed"
        googleAnalyticsParams={{
          category: 'flights_summary',
          action: 'hotels_in_flights',
          label: 'hotels-in-flights_not-displayed_pag:summary',
        }}
      />
    );
  }

  return isPrime ? (
    <FlightSummaryHotelsMapPrime {...props} />
  ) : (
    <FlightSummaryHotelsMapNonPrime {...props} />
  );
};
